@if (visibleToasts().length > 0 && showPill()) {
    <button
        aria-label="Toggle pending approvals"
        class="approval-toast-pill"
        data-testid="approval-toast-pill"
        type="button"
        [attr.aria-expanded]="approvalsOpen()"
        (click)="toggleMobileStack()">
        <span class="approval-toast-pill__count">{{ approvalCount() }}</span>
        {{ approvalCount() === 1 ? 'approval waiting' : 'approvals waiting' }}
        <wa-icon aria-hidden="true" class="approval-toast-pill__chevron" [attr.name]="approvalsOpen() ? 'chevron-down' : 'chevron-up'" />
    </button>
}

@if (visibleToasts().length > 0 && stackVisible()) {
    <div aria-label="Pending approvals" class="approval-toast-stack" role="region">
        @if (approvalCount() > 1) {
            <article class="approval-toast-bulk" data-testid="approval-toast-bulk-panel">
                <button
                    aria-label="Dismiss all approval toasts"
                    class="approval-toast-bulk__dismiss"
                    data-testid="approval-toast-dismiss-all"
                    type="button"
                    (click)="onDismissAll()">
                    &times;
                </button>
                <h2 class="approval-toast-bulk__title">Approvals</h2>
                @if (extraApprovalCount() > 0) {
                    <p class="approval-toast-bulk__text">
                        +{{ extraApprovalCount() }} more {{ extraApprovalCount() === 1 ? 'Approval' : 'Approvals' }} waiting on the
                        <a class="approval-toast-bulk__link" [routerLink]="['/chat/workspace', 'approvals']">Approvals Page</a>
                    </p>
                }
                @if (bulkConfirmAction()) {
                    <p class="approval-toast-bulk__confirm" data-testid="approval-toast-bulk-confirm">
                        Are you sure you want to {{ bulkConfirmLabel() }}?
                    </p>
                    <div class="approval-toast-bulk__actions">
                        <button
                            class="approval-toast__btn approval-toast__btn--always"
                            data-testid="approval-toast-bulk-no"
                            type="button"
                            (click)="onCancelBulkConfirm()">
                            No
                        </button>
                        <button
                            class="approval-toast__btn approval-toast__btn--primary"
                            data-testid="approval-toast-bulk-yes"
                            type="button"
                            (click)="onConfirmBulkAction()">
                            Yes
                        </button>
                    </div>
                } @else {
                    <div class="approval-toast-bulk__actions">
                        <button
                            class="approval-toast__btn approval-toast__btn--reject"
                            data-testid="approval-toast-reject-all"
                            type="button"
                            [disabled]="!!bulkBusy()"
                            (click)="askBulkConfirm('reject')">
                            {{ bulkBusy() === 'reject' ? 'Rejecting…' : 'Reject All' }}
                        </button>
                        <button
                            class="approval-toast__btn approval-toast__btn--primary"
                            data-testid="approval-toast-approve-all"
                            type="button"
                            [disabled]="!!bulkBusy()"
                            (click)="askBulkConfirm('approve')">
                            {{ bulkBusy() === 'approve' ? 'Approving…' : 'Approve All' }}
                        </button>
                    </div>
                }
            </article>
        }
        @for (toast of visibleToasts(); track trackById($index, toast)) {
            @if (toast.tier === 2) {
                <!-- Tier-2: held send with countdown (ADR-0011) -->
                <article class="approval-toast approval-toast--held" data-testid="approval-toast-held">
                    <div class="approval-toast__head">
                        <div class="approval-toast__title-block">
                            <span class="approval-toast__tool">{{ approvalTitle(toast.item) }}</span>
                        </div>
                        <span class="approval-toast__countdown" data-testid="approval-toast-countdown"
                            >Sends in {{ bar.remainingSeconds() }}s</span
                        >
                    </div>
                    @if (targetLabel(toast.item) || scopeLabel(toast.item)) {
                        <div class="approval-toast__meta-row">
                            @if (targetLine(toast.item); as target) {
                                <p class="approval-toast__recipient" data-testid="approval-toast-target">
                                    {{ targetPrefix(toast.item) }} {{ target.shown }}
                                    @if (target.hidden) {
                                        <button class="approval-toast__more" type="button" (click)="expandRecipients(toast.item.id)">
                                            +{{ target.hidden }} more
                                        </button>
                                    }
                                </p>
                            }
                            @if (scopeLabel(toast.item); as scope) {
                                <span class="approval-toast__scope-reason">{{ scope }}</span>
                            }
                        </div>
                    }
                    @if (summary(toast.item)) {
                        <p class="approval-toast__summary">{{ summary(toast.item) }}</p>
                    }
                    <div class="approval-toast__actions">
                        <button
                            class="approval-toast__btn approval-toast__btn--cancel"
                            data-testid="approval-toast-cancel"
                            type="button"
                            [disabled]="toast.busy === 'cancel'"
                            (click)="onCancel(toast.item.id)">
                            {{ toast.busy === 'cancel' ? 'Cancelling…' : 'Cancel' }}
                        </button>
                    </div>
                    <app-hold-drain-bar #bar [createdAt]="toast.item.created_at" [fireAt]="toast.item.fire_at" />
                </article>
            } @else {
                <!-- Tier-1: ask-level pending approval -->
                <article class="approval-toast" data-testid="approval-toast">
                    <button
                        aria-label="Dismiss"
                        class="approval-toast__dismiss"
                        data-testid="approval-toast-dismiss"
                        type="button"
                        (click)="onDismiss(toast.item.id)">
                        &times;
                    </button>
                    <div class="approval-toast__head">
                        <div class="approval-toast__title-block">
                            <span class="approval-toast__tool">{{ approvalTitle(toast.item) }}</span>
                        </div>
                    </div>
                    @if (targetLabel(toast.item) || scopeLabel(toast.item)) {
                        <div class="approval-toast__meta-row">
                            @if (targetLine(toast.item); as target) {
                                <p class="approval-toast__recipient" data-testid="approval-toast-target">
                                    {{ targetPrefix(toast.item) }} {{ target.shown }}
                                    @if (target.hidden) {
                                        <button class="approval-toast__more" type="button" (click)="expandRecipients(toast.item.id)">
                                            +{{ target.hidden }} more
                                        </button>
                                    }
                                </p>
                            }
                            @if (scopeLabel(toast.item); as scope) {
                                <span class="approval-toast__scope-reason">{{ scope }}</span>
                            }
                        </div>
                    }
                    @if (summary(toast.item)) {
                        <p class="approval-toast__summary">{{ summary(toast.item) }}</p>
                    }
                    @if (previewBody(toast.item); as body) {
                        <div
                            class="approval-toast__preview"
                            data-testid="approval-toast-preview"
                            [class.approval-toast__preview--expandable]="isPreviewExpandable(toast.item)"
                            [class.approval-toast__preview--expanded]="isPreviewExpanded(toast.item.id)">
                            @if (isPreviewExpandable(toast.item)) {
                                <button
                                    class="approval-toast__preview-toggle"
                                    data-testid="approval-toast-preview-toggle"
                                    type="button"
                                    [attr.aria-label]="
                                        isPreviewExpanded(toast.item.id) ? 'Collapse message preview' : 'Expand message preview'
                                    "
                                    (click)="togglePreview(toast.item)">
                                    <wa-icon [name]="isPreviewExpanded(toast.item.id) ? 'chevron-up' : 'chevron-down'" />
                                </button>
                            }
                            @if (isEmailApproval(toast.item)) {
                                <div class="approval-toast__preview-lines">
                                    @if (previewSubject(toast.item); as subject) {
                                        <p><strong>Subject:</strong> {{ subject }}</p>
                                    }
                                    <p><strong>Body:</strong> {{ body }}</p>
                                </div>
                            } @else {
                                <span>{{ body }}</span>
                            }
                        </div>
                    }
                    @if (chooserOpenId() === toast.item.id) {
                        <app-scope-chooser
                            confirmLabel="Approve Always"
                            data-testid="approval-toast-scope-chooser"
                            [busy]="toast.busy === 'always'"
                            [rungs]="rungs(toast.item)"
                            (cancelled)="onScopeCancel()"
                            (confirmed)="onScopeConfirm(toast.item.id, $event)" />
                    } @else {
                        <div class="approval-toast__actions">
                            <button
                                class="approval-toast__btn approval-toast__btn--view"
                                data-testid="approval-toast-view"
                                type="button"
                                (click)="openView(toast.item)">
                                View
                            </button>
                            <button
                                class="approval-toast__btn approval-toast__btn--reject"
                                data-testid="approval-toast-reject"
                                type="button"
                                [disabled]="!!toast.busy"
                                (click)="onReject(toast.item.id)">
                                {{ toast.busy === 'reject' ? 'Rejecting…' : 'Reject' }}
                            </button>
                            <button
                                class="approval-toast__btn approval-toast__btn--primary"
                                data-testid="approval-toast-approve"
                                type="button"
                                [disabled]="!!toast.busy"
                                (click)="onApprove(toast.item.id)">
                                {{ toast.busy === 'approve' ? 'Approving…' : 'Approve' }}
                            </button>
                            <button
                                class="approval-toast__btn approval-toast__btn--always"
                                data-testid="approval-toast-approve-always"
                                type="button"
                                [disabled]="!!toast.busy"
                                (click)="onApproveAlways(toast.item.id)">
                                {{ toast.busy === 'always' ? 'Saving…' : 'Approve Always' }}
                            </button>
                        </div>
                    }
                </article>
            }
        }
    </div>
}

@if (viewingItem()) {
    <app-email-review-dialog
        sectionLabel="Pending approval"
        [approvalActions]="true"
        [card]="viewCard()!"
        [item]="viewItemView()!"
        [rowIndex]="0"
        [rungs]="viewingItem() ? rungs(viewingItem()!) : []"
        (approve)="onViewApprove()"
        (approveAlwaysConfirmed)="onViewScopeConfirm($event)"
        (closed)="closeView()"
        (reject)="onViewReject()" />
}
